export default class SimpleChecklistItem{
    constructor(id, content_id){
        this.id = id;
        this.content_id = content_id;
        this.headline = '';
        this.checked = false;
        this.checkedForContact = [];
    }
}